
import { Dialog, DialogTitle, DialogContent, Button } from '@mui/material';
import { React, useState, useMemo } from 'react';
import { useMyContext } from '../../../context/MyContext';
import { RiMoneyRupeeCircleFill } from "react-icons/ri";
import { useNavigate } from 'react-router-dom';
import { IoMdArrowRoundBack } from "react-icons/io";
import '../../../css/custom-scrollbar.css';
import { IoIosCloseCircle } from "react-icons/io";

const ViewRateForword = ({ isopen, onClose, data }) => {
  const { isDarkMode } = useMyContext();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const userData = JSON.parse(localStorage.getItem('user')) || {};

  const handleNavigation = () => {
    navigate('/shipments/forward');
  };

  // Dynamic table data generation with support for future partner additions
  const tableData = useMemo(() => {
    if (!data?.data?.partners_pricing) return [];

    // Collect all partners dynamically
    const allPartners = Object.keys(data.data.partners_pricing);

    // Flatten and transform pricing data for all partners
    return allPartners.flatMap(partner =>
      Object.entries(data.data.partners_pricing[partner] || {}).map(([mode, pricing], index) => ({
        id: `${partner}-${mode}-${index}`,
        courier: partner.toLowerCase(),
        mode,
        zone: data.data.zone,
        basePrice: pricing.total_price,
        codExtra: pricing.cod_extra,
        // Handling cases where cod_total_price might be 0
        codTotalPrice: pricing.cod_total_price !== 0
          ? pricing.cod_total_price
          : pricing.total_price,
        shippingMode: mode,
        // Spread any additional partner-specific data
        ...pricing
      }))
    );
  }, [data]);

  const handleClose = () => {
    onClose();
  };

  // Dynamically generate table headers based on available data
  const tableHeaders = useMemo(() => {
    const baseHeaders = [
      'Courier',
      'Mode',
      'Zone',
      'Forward Price',
      'COD Price',
      'Total Price'
    ];
    return baseHeaders;
  }, [tableData]);

  return (
   <Dialog
  open={isopen}
  onClose={onClose}
  maxWidth="sm"
  className={`shadow-custom-light rounded-xl dark:shadow-custom-dark mt-4 ml-2 mr-2 p-4 
    ${isDarkMode ? "dark:bg-darkmodeColor text-white" : ""}`}
  sx={{
    '& .MuiDialog-paper': {
      width: '80%',
      height: '65vh',
      backdropFilter: "blur(5px) sepia(5%)",
      borderRadius: "24px",
      display: 'flex',
      flexDirection: 'column'
    }
  }}
>
  <DialogTitle className="bg-customPurple text-white text-center">
    <h2 className="text-sm font-semibold flex items-center justify-center">
      <RiMoneyRupeeCircleFill />
      Rate Calculator
    </h2>
    <IoIosCloseCircle
      className="absolute top-2 right-2 cursor-pointer"
      size={32}
      onClick={handleClose}
    />
  </DialogTitle>

  <DialogContent
    className={`mt-2 ml-1 mr-1 custom-scrollbar flex-1
    ${isDarkMode ? "dark:bg-darkmodeColor text-white" : ""}`}
    sx={{ 
      overflowY: 'auto',
      padding: '0 8px'
    }}
  >
    <div className="bg-white dark:bg-darkmodeColor rounded-xl overflow-x-auto shadow-sm overflow-hidden mt-2 mb-0">
      <table className="min-w-full table-auto min-h-[300px]" >
        <thead className="bg-customPurple text-white text-[10px] dark:bg-darkmodeColor dark:text-white">
          <tr className='text-xs'>
            {tableHeaders.map((header, index) => (
              <th key={index} className="px-1 py-2 text-left text-xs font-normal">{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.length > 0 ? (
            tableData.map((row) => (
              <tr key={row.id} className="border-b text-xs">
                <td className="p-2">
                  <div className="flex items-center">
                    {row.courier?.toLowerCase() === "delhivery" && (
                      <img
                        src={isDarkMode ? "/assets/images/DELHIVERYWhite.png" : "/assets/images/Delhivery.png"}
                        alt="Delhivery"
                        className="h-[7px] w-auto object-contain"
                      />
                    )}
                    {row.courier?.toLowerCase() === "ecom" && (
                      <img
                        src={isDarkMode ? "/assets/images/logoecom.svg" : "/assets/images/ecom-express-logo.png"}
                        alt="Ecom Express"
                        className={`object-contain w-auto ${isDarkMode ? "h-2" : "h-10"}`}
                      />
                    )}
                    {row.courier?.toLowerCase() === "ekart" && (
                      <img
                        src="/assets/images/ekart.png"
                        alt="Ekart"
                        className="h-6 w-auto object-contain"
                      />
                    )}
                    {row.courier?.toLowerCase() === "xpressbees" && (
                      <img
                        src={isDarkMode ? "/assets/images/xpressbess.png" : "/assets/images/xpressbess.png"}
                        alt="XpressBees"
                        className="h-[10px] w-auto object-contain"
                      />
                    )}
                    {row.courier?.toLowerCase() === "bluedart" && (
                      <img
                        src={isDarkMode ? "/assets/images/bluedart.png" : "/assets/images/bluedart.png"}
                        alt="bluedart"
                        className="h-[10px] w-auto object-contain"
                      />
                    )}
                     {row.courier?.toLowerCase() === "pickupxpress" && (
                      <img
                        src={isDarkMode ? "/assets/images/logo1.png" : "/assets/images/logo1.png"}
                        alt="bluedart"
                        className="h-[30px] w-auto object-contain"
                      />
                    )}x
                    {!["delhivery", "ecom", "ekart", "xpressbees","bluedart","pickupxpress"].includes(row.courier?.toLowerCase()) && (
                      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200">
                        {row.courier}
                      </span>
                    )}
                  </div>
                </td>
                <td className="p-2 text-left font-medium">{row.mode || "N/A"}</td>
                <td className="p-2 text-left font-medium">{row.zone || "N/A"}</td>
                <td className="p-2 text-left font-medium">{row.basePrice ? `₹ ${row.basePrice}` : "N/A"}</td>
                <td className="p-2 text-left font-medium">{row.codExtra ? `₹ ${row.codExtra}` : "N/A"}</td>
                <td className="p-2 text-left font-medium">{row.codTotalPrice ? `₹ ${row.codTotalPrice}` : "N/A"}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td className="p-2 text-center" colSpan={tableHeaders.length}>
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </DialogContent>

  <div className="flex justify-center md:justify-end px-2 py-1 mt-0 bg-white dark:bg-darkmodeColor">
    <button onClick={handleNavigation}
      className="w-full md:w-auto px-2 py-2 font-semibold font-sans text-black rounded-md flex items-center justify-center">
      <IoMdArrowRoundBack />
      Create Forward Order
    </button>
  </div>
</Dialog>
  );
};
export default ViewRateForword;
